import axios from '../http'

function get(id) {
    return axios.get('/event/project/get?id=' + id);
}

function findByGameId(gameId) {
    return axios.post('/event/project/findByGameId?gameId='+gameId);
}

function query(data) {
    return axios.post('/event/project/query', data);
}

function printEntry(id) {
    const url = "/event/project/printEntry?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function exportEntry(id){
    const url = "/event/project/exportEntry?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Entries by Event.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}



function issueResult(id) {
    return axios.get('/event/project/issueResult?id=' + id);
}


function printStartOrder(id) {
    const url = "/event/project/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function printResultOrder(id) {
    const url = "/event/project/printResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function findOptions() {
    return axios.post('/event/project/findOptions');
}

function mergeTo(data) {
    return axios.post('/event/project/mergeTo', data);
}

function revertMergeTo(id) {
    return axios.get('/event/project/revertMergeTo?id=' + id);
}
function heatGroup(data) {
    return axios.post('/event/project/heatGroup', data);
}

function revertHeatGroup(id) {
    return axios.get('/event/project/revertHeatGroup?id=' + id);
}

export default {
    get,
    query,
    printEntry,
    exportEntry,
    issueResult,
    findByGameId,
    printStartOrder,
    printResultOrder,
    findOptions,
    mergeTo,
    revertMergeTo,
    heatGroup,
    revertHeatGroup
}